import { render, staticRenderFns } from "./GraficaZonas.vue?vue&type=template&id=05d83068"
import script from "./GraficaZonas.vue?vue&type=script&lang=js"
export * from "./GraficaZonas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports